import { render } from "./ClienteEditar.vue?vue&type=template&id=35e9679c"
import script from "./ClienteEditar.vue?vue&type=script&lang=js"
export * from "./ClienteEditar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__